'use client';

import Box from '@enlighten/design-system/dist/Box';
import Button from '@enlighten/design-system/dist/Button';
import React from 'react';

import { EthicalForm } from '@/components/pages/ethical-report';

const FormSection = () => {
	const [open, setOpen] = React.useState(false);

	return (
		<Box display="flex" justifyContent="center">
			{open ? (
				<EthicalForm />
			) : (
				<Box width="280px">
					<Button fullWidth onClick={() => setOpen(true)}>
						Speak up
					</Button>
				</Box>
			)}
		</Box>
	);
};

export default FormSection;
